import { render, staticRenderFns } from "./AddExist.vue?vue&type=template&id=01641b8e&scoped=true"
import script from "./AddExist.vue?vue&type=script&lang=js"
export * from "./AddExist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01641b8e",
  null
  
)

export default component.exports